export const supportsBaseSelect = () => {
  return (
    typeof window !== "undefined" &&
    window.CSS &&
    window.CSS.supports &&
    window.CSS.supports("appearance", "base-select")
  );
};
